import { render, staticRenderFns } from "./OverPassPlugin.vue?vue&type=template&id=533f8de0&scoped=true"
import script from "./OverPassPlugin.vue?vue&type=script&lang=ts"
export * from "./OverPassPlugin.vue?vue&type=script&lang=ts"
import style0 from "./OverPassPlugin.vue?vue&type=style&index=0&id=533f8de0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f8de0",
  null
  
)

export default component.exports